<template>
  <v-container fluid fill-height>
    <v-flex>
      <v-layout v-if="!(jitsi && hasActiveRoom)">
        <v-flex xs12>
          <v-img src="/empty_video_conference.png" class="center" style="transform: scale(0.5);"></v-img>
        </v-flex>
      </v-layout>
      <v-flex class="d-flex justify-center" v-if="jitsi && hasActiveRoom">
        <v-card style="width: 500px;margin-top: 20px;">
          <v-app-bar>
            <v-icon style="margin-right: 10px;height: 420px;">mdi-information-outline</v-icon>
            <v-toolbar-title>{{ $t('videoconf.info.title') }}</v-toolbar-title>
          </v-app-bar>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"> {{ $t('videoconf.info.info') }} </th>
                  <th class="text-left"> {{ $t('videoconf.info.value') }} </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in infos" :key="item.name" v-show="!!item.value">
                  <td>{{ $t(item.name) }}</td>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        <v-card-actions></v-card-actions>
      </v-card>
      </v-flex>
      <v-flex class="d-flex justify-center" v-if="jitsi && hasActiveRoom">
        <v-card style="width: 500px;margin-top: 20px;">
          <v-app-bar>
            <v-icon style="margin-right: 10px;height: 420px;">mdi-account-group</v-icon>
            <v-toolbar-title>{{ $t('videoconf.users.title') }}</v-toolbar-title>
          </v-app-bar>
          <div style="height:400px;overflow-y:auto;">
            <v-list dense :disabled="true">
              <v-list-item-group active-class="primary--text">
                <template v-for="(user) in users">
                  <v-list-item :key="user.username" :value="user.id">
                  <template>
                    <v-list-item-avatar><v-img :src="user.picture_profile_url"></v-img></v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="user.name"></v-list-item-title>
                      <v-list-item-subtitle class="text--grey" v-text="user.username"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text v-text="selectText(user)" style="width: 65px;text-align: center;"></v-list-item-action-text>
                      <v-icon :color="selectColor(user)" style="margin-right: 20px">
                        {{selectIcon(user)}}
                      </v-icon>
                    </v-list-item-action>
                  </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </div>

        <v-card-actions></v-card-actions>
      </v-card>
      </v-flex>
    </v-flex>
  </v-container>
</template>

<script>
/* global JitsiMeetExternalAPI */
import { mapGetters, mapActions } from 'vuex'
import events from 'Store/events'

export default {
  name: 'video-conferences',
  data () {
    return {
      numberOfParticipant: 0,
      participants: [],
      users: [],
      headerUsers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Status', value: 'status' }
      ]
    }
  },
  mounted () {
    this.refreshData()
  },
  watch: {
    activeRoom: function (room) {
      if (room && !this.hasJoined) {
        this.docked = true
        this.createAndJoin(room)
      }
    }
  },
  computed: {
    ...mapGetters({
      userName: 'sipuaClidName',
      activeRoom: 'videoconfer/activeRoom',
      getJitsi: 'videoConferenceOverlay/jitsi',
      getHasJoined: 'videoConferenceOverlay/hasJoined',
      getDocked: 'videoConferenceOverlay/docked',
      currentUsername: 'settings/userName'
    }),
    docked: { get () { return this.getDocked }, set (docked) { this.setDocked(docked) } },
    jitsi: { get () { return this.getJitsi }, set (jitsi) { this.setJitsi(jitsi) } },
    hasJoined: { get () { return this.getHasJoined }, set (hasJoined) { this.setHasJoined(hasJoined) } },
    hasActiveRoom: function () { return this.activeRoom !== null },
    phoneNumbers () { return this.activeRoom.phone_numbers.join(', ') },
    infos: function () {
      return [
        { name: 'videoconf.info.items.participant_in_meeting', value: this.numberOfParticipant },
        { name: 'videoconf.info.items.users_count', value: this.activeRoom.users_count },
        { name: 'videoconf.info.items.guest_url', value: this.activeRoom.guestURL },
        { name: 'videoconf.info.items.expireAt', value: this.activeRoom.expireAt },
        { name: 'videoconf.info.items.extension', value: this.activeRoom.username },
        { name: 'videoconf.info.items.phone_numbers', value: this.phoneNumbers },
        { name: 'videoconf.info.items.roomNumber', value: this.phoneNumbers ? this.activeRoom.roomNumber : null },
        { name: 'videoconf.info.items.roomPin', value: this.phoneNumbers ? this.activeRoom.roomPin : null },
        { name: 'videoconf.info.items.sharedScreenAdmin', value: this.$t(`videoconf.info.items.enabled.${this.activeRoom.sharedScreenAdmin}`) },
        { name: 'videoconf.info.items.sharedScreenGuest', value: this.$t(`videoconf.info.items.enabled.${this.activeRoom.sharedScreenGuest}`) },
        { name: 'videoconf.info.items.recordingAdmin', value: this.$t(`videoconf.info.items.enabled.${this.activeRoom.recordingAdmin}`) },
        { name: 'videoconf.info.items.recordingGuest', value: this.$t(`videoconf.info.items.enabled.${this.activeRoom.recordingGuest}`) }
      ]
    }
  },
  methods: {
    ...mapActions({
      destroyRoom: 'videoconfer/destroyActiveRoom',
      setJitsi: 'videoConferenceOverlay/setJitsi',
      setHasJoined: 'videoConferenceOverlay/setHasJoined',
      setDocked: 'videoConferenceOverlay/setDocked'
    }),
    createAndJoin: function (room) {
      this.removeRoomElement()
      const options = {
        roomName: room.jitsiRoom,
        parentNode: document.querySelector('[id=meetRoom]'),
        onload: this.jitsiFrameLoaded,
        width: '100%',
        height: '100%',
        jwt: room.getJwt(this.currentUsername),
        interfaceConfigOverwrite: {
          DEFAULT_REMOTE_DISPLAY_NAME: this.userName,
          DEFAULT_LOGO_URL: '/clearlyip-icon-32.png',
          DEFAULT_WELCOME_PAGE_LOGO_URL: '/clearlyip-icon-32.png',
          BRAND_WATERMARK_LINK: '/clearlyip-icon-32.png',
          JITSI_WATERMARK_LINK: '',
          SHOW_BRAND_WATERMARK: true,
          SHOW_JITSI_WATERMARK: false,
          HIDE_DEEP_LINKING_LOGO: false,
          DEFAULT_BACKGROUND: this.$vuetify.theme.dark ? '#000000' : '#ffffff'
        },
        configOverwrite: {
          prejoinPageEnabled: false
        },
        userInfo: {
          displayName: this.userName
        }
      }
      try {
        const ltxt = this.activeRoom
          ? 'videoconf.rejoin'
          : 'videoconf.loading'
        events.mask(this.$t(ltxt, { room: room.name }))
        this.jitsi = new JitsiMeetExternalAPI(room.domain, options)
        this.jitsi.addListener('videoConferenceLeft', () => { this.destroyRoom() })
        this.jitsi.addListener('videoConferenceJoined', () => { this.refreshData() })
        this.jitsi.addListener('participantJoined', () => { this.refreshData() })
        this.jitsi.addListener('participantKickedOut', () => { this.refreshData() })
        this.jitsi.addListener('participantLeft', () => { this.refreshData() })
        this.dbg(this.jitsi.getParticipantsInfo())
      } catch (err) {
        events.unmask()
        events.pubError('Failed load jitsi conference')
        this.dbg('Failed load jitsi: %o', err)
      }
    },
    jitsiFrameLoaded () {
      events.unmask()
    },
    refreshData () {
      this.participants = this.jitsi?.getParticipantsInfo()
      this.numberOfParticipant = this.participants?.length
      this.setUsers()
    },
    removeRoomElement () {
      if (!this.jitsi) { return }
      const iframe = this.jitsi.getIFrame()
      const parent = document.querySelector('[id=meetRoom]')
      parent.removeChild(iframe)
    },
    // used though emit in list/item component
    hangupRoom () {
      if (this.jitsi) {
        this.jitsi.executeCommand('hangup')
      }
    },
    setUsers () {
      const users = this.activeRoom?.users
      const data = []
      if (users) {
        users.forEach(user => {
          user.status = this.participants.find((participant) => (participant.displayName === user.name))
          data.push(user)
        })
        data.sort((a, b) => (a.status) ? -1 : ((b.status) ? 1 : 0))
        this.users = data
      }
    },
    selectText (user) {
      return user.status ? this.$t('videoconf.users.online') : this.$t('videoconf.users.offline')
    },
    selectIcon (user) {
      return user.status ? 'mdi-account-circle' : 'mdi-account-circle-outline'
    },
    selectColor (user) {
      return user.status ? 'primary' : 'grey'
    }
  }
}
</script>

<style scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
